// extracted by mini-css-extract-plugin
export default {"table":"selectorTable_table__6hCbQ"};